module.exports = __webpack_public_path__ + "static/icons-white-outlines-1c164b33dae57019cf2a5c62ccbaa5b8.png";